module.exports = __webpack_public_path__ + "static/media/Muli-Bold.67611879.svg";